import {
  CONSTRUCTION_YEAR_LIMIT,
  CONSTRUCTION_YEAR_LIMIT_RENTAL,
  CONSTRUCTION_YEAR_LIMIT_SECURITY_QUESTIONS,
  CONSTRUCTION_YEAR_LIMIT_SUPER,
  OLD_HOUSE_AGE,
} from "../houseConstants";

import { getAgeFromYear } from "Utils/dateUtils";
import { isDefined } from "Utils/functions";

export const isConstructionYearFieldInvalid = (
  constructionYear: string | undefined,
): boolean =>
  isDefined(constructionYear) &&
  houseBuiltBeforeConstructionYearLimit(Number(constructionYear)) &&
  constructionYear.length === 4;

export const wasHouseBuiltBeforeLimit = (constructionYear: number): boolean =>
  constructionYear < CONSTRUCTION_YEAR_LIMIT_SECURITY_QUESTIONS;

export const houseBuiltBeforeConstructionYearLimitWhenRental = (
  constructionYear: number,
): boolean => {
  return constructionYear < CONSTRUCTION_YEAR_LIMIT_RENTAL;
};

export const houseBuiltBeforeSuperCoverageConstructionYearLimit = (
  constructionYear: number,
): boolean => {
  return constructionYear < CONSTRUCTION_YEAR_LIMIT_SUPER;
};

export const houseBuiltBeforeConstructionYearLimit = (
  constructionYear: number,
): boolean => {
  return constructionYear < CONSTRUCTION_YEAR_LIMIT;
};

export const isHouseOld = (constructionYear: number): boolean => {
  return getAgeFromYear(constructionYear) > OLD_HOUSE_AGE;
};
